export enum ENUM_COOKIES_TYPES {
  IS_AUTH = "isAuth",
  IS_AUTH_ECP = "isAuthEcp",
  ROLE = "role",
  USER_ID = "user_id",
  TOKEN = "adv-blog",
  GUEST_ID = "guest_id",
  IS_CHANNEL_REPLACED = "is_channel_replaced",
  CERTIFICATE_USER_KEY = "certificate_user_key",
}
